<template>
    <div>
        <div class="row form-group justify-content-content" v-if="rowsData && selectViewGroup !== 'workflow'">
            <div class="col-3">
                <div class="row">
                    <div class="col-3 m-auto">
                        <span class="m-auto"> {{ $t("그룹") }}: </span>
                    </div>
                    <div class="col-9">
                        <select class="form-control" v-model="selectWorkflowGroup">
                            <option value="All">{{ $t("전체") }}</option>
                            <option v-for="(group, i) in workflowGroups" :key="i">
                                {{ group.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row form-group" v-if="calcPointList.length !== 0 && selectViewGroup !== 'group'">
            <div class="col-12">
                <table class="table table-bordered m-b-0 text-center">
                    <thead class="bg-warning">
                        <tr>
                            <th
                                :style="{
                                    color: '#ffffff',
                                    minWidth: '150px',
                                    verticalAlign: 'middle',
                                }"
                            >
                                {{ $t("기록 시간") }}
                            </th>
                            <th
                                v-for="(ptAddr, i) in calcPointList"
                                :key="`head${i}`"
                                :style="{
                                    color: '#ffffff',
                                    minWidth: '120px',
                                    verticalAlign: 'middle',
                                }"
                            >
                                <p :style="{ margin: 0, fontWeight: 900 }">
                                    {{ `${ptAddr} ` }}
                                </p>
                                <p :style="{ margin: 0, fontWeight: 200 }">
                                    {{
                                        `${
                                            !pointList.find((v) => v.ptAddr === ptAddr)
                                                ? "-"
                                                : pointList.find((v) => v.ptAddr === ptAddr).ptName
                                        }`
                                    }}
                                </p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pointLive, j) in stackedLiveData" :key="`livePoint${j}`">
                            <td :style="{ verticalAlign: 'middle' }">
                                {{ moment(pointLive.regDt, "YYYYMMDDHHmm").format("YYYY-MM-DD HH:mm") }}
                            </td>
                            <td
                                v-for="(data, i) in pointLive.datas"
                                :key="`originvalue${i}`"
                                :style="{ verticalAlign: 'middle' }"
                            >
                                <!-- {{ data }} -->
                                <a v-if="!data">{{ "-" }}</a>
                                <a v-else>{{ data.ptVal === null ? "-" : parseFloat(data.ptVal.toFixed(3)) }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- </b-tab> -->
        <!-- <b-tab title="그룹 계산식 적용 값" v-if="rowsData && selectViewGroup !== 'workflow'"> -->
        <div class="row form-group" v-if="rowsData && selectViewGroup !== 'workflow'">
            <div class="col-lg-12">
                <div>
                    <table class="table table-bordered m-b-0">
                        <thead>
                            <tr :style="{ textAlign: 'center' }">
                                <th
                                    class="bg-primary width-30"
                                    :style="{
                                        verticalAlign: 'middle',
                                        minWidth: '150px',
                                        color: '#fff',
                                    }"
                                >
                                    {{ $t("기록시간") }}
                                </th>
                                <th
                                    class="cursor-pointer bg-primary"
                                    v-for="(text, i) in headerColumns.columns"
                                    :key="i"
                                    :style="{
                                        verticalAlign: 'middle',
                                        minWidth: '120px',
                                        color: '#fff',
                                    }"
                                    data-toggle="tooltip"
                                    title="Some tooltip text!"
                                >
                                    {{ text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(rows, i) in rowsData"
                                :key="i"
                                class="cursor-pointer"
                                :style="{ textAlign: 'center' }"
                            >
                                <td :style="{ verticalAlign: 'middle' }">
                                    {{ moment(rows.regDt, "YYYYMMDDHHmm").format("YYYY-MM-DD HH:mm") }}
                                </td>

                                <td
                                    v-for="(row, j) in rows.datas"
                                    :key="j"
                                    :class="[isSelect(row) ? 'bg-orange' : 'bg-white']"
                                    :style="{ verticalAlign: 'middle' }"
                                >
                                    <!-- {{ row }} -->
                                    {{ Number(row.ptVal).toFixed(3) ?? "-" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.collapsed > .when-open,
.not-collapsed > .when-closed {
    display: none;
}
</style>

<script>
import moment from "moment";

// 짧은 틱 + 분 floor 키 + upsert 조합으로 분당 1행으로 수렴시킨다.
// (한 분에 여러 번 틱해도 같은 분 행에 upsert 되므로 드리프트/탭 throttle 에 강하다)
const STACK_TICK_MS = 30 * 1000;
const MAX_STACK_ROWS = 10;

export default {
    props: [
        "selectViewGroup",
        "currentWorkflow",
        "currentUpl",
        "liveReals",
        "currentLiveDate",
        "select-row",
        "calcPointData",
        "pointList",
        "ptMapData",
        "commonCodeList",
        "calcPointList",
    ],
    data() {
        return {
            moment,
            etcSelectInfoList: [],
            tooltipData: {},
            selectWorkflowGroup: "ALL",
            // 분 단위 라이브 스택(이 컴포넌트 소유). [{ regDt, datas: [{ ptAddr, ptVal }] }]
            liveStackRows: [],
            stackTimer: null,
        };
    },
    mounted() {
        this.etcSelectInfoList.push({
            label: "관제점 단위",
            code: "unitSmallCodeName",
        });
        this.etcSelectInfoList.push({
            label: "사용 에너지원",
            code: "energySourceCode",
        });
        this.etcSelectInfoList.push({
            label: "에너지공급구분코드",
            code: "energySplyTypeCode",
        });
        this.etcSelectInfoList.push({
            label: "관제점 용도",
            code: "ItemUseageCode",
        });
        this.etcSelectInfoList.push({ label: "적용구역", code: "applyZoneIdx" });

        this.startLiveStack();
    },
    beforeDestroy() {
        this.stopLiveStack();
    },
    computed: {
        workflowGroups() {
            if (
                this.currentWorkflow &&
                this.currentWorkflow.workflow &&
                Array.isArray(this.currentWorkflow.workflow.children)
            )
                return this.currentWorkflow.workflow.children;
            else return [];
        },

        headerColumns() {
            let columns = [];
            let ptAddrs = [];
            let filterGroups = [];

            if (this.selectWorkflowGroup == "All") filterGroups = this.workflowGroups.filter((group) => group);
            else filterGroups = this.workflowGroups.filter((group) => group.name == this.selectWorkflowGroup);

            filterGroups.map((group) => {
                columns = columns.concat(group.children.map((v) => v.name));
                ptAddrs = ptAddrs.concat(group.children.map((v) => v.ptAddr));
            });

            return { columns, ptAddrs };
        },
        /**
         * 스택에 실제로 누적할 관제점 = 두 테이블이 표시하는 ptAddr 의 합집합.
         * 표시 대상만 스냅샷하므로 totalReal 전체(수백 점)를 매 틱 복사하지 않는다.
         */
        displayPtAddrs() {
            const set = new Set();
            (this.calcPointList || []).forEach((p) => p && set.add(p));
            (this.headerColumns.ptAddrs || []).forEach((p) => p && set.add(p));
            return Array.from(set);
        },
        isHighlight() {
            return (text) => {
                return this.isEmpty(this.currentUpl) || this.currentUpl.name != text ? false : true;
            };
        },

        // fullColumns() {
        //   // 해당 workflow의 모든 계산식 이름과 주소값
        //   let columns = [];
        //   let ptAddrs = [];

        //   this.workflowGroups.map((group) => {
        //     columns = columns.concat(group.children.map((v) => v.name));
        //     ptAddrs = ptAddrs.concat(group.children.map((v) => v.ptAddr));
        //   });

        //   return { columns, ptAddrs };
        // },
        isSelect() {
            return (row) => {
                return this.currentLiveDate == row.ptVal;
            };
        },
        // 그룹 계산식 테이블: 로컬 스택을 그룹 컬럼(headerColumns.ptAddrs)으로 추려서 구성.
        rowsData() {
            return this.buildRows(this.headerColumns.ptAddrs);
        },

        // 워크플로우 스택 테이블: 로컬 스택을 선택 관제점(calcPointList)으로 추려서 구성.
        stackedLiveData() {
            return this.buildRows(this.calcPointList);
        },
    },
    watch: {
        currentUpl: function (newV) {
            if (newV.uplType == "Start") this.selectWorkflowGroup = "All";
            else if (newV.uplType == "Group") this.selectWorkflowGroup = newV.name;
            else {
                this.workflowGroups.map((group) => {
                    let parent = group.children.find((v) => v.name == newV.name);
                    if (parent) this.selectWorkflowGroup = group.name;
                });
            }
        },
        // 표시 관제점이 바뀌면(워크플로우/그룹 전환) 다음 틱을 기다리지 않고 즉시 한 번 스냅샷해
        // 새 컬럼이 바로 채워지게 한다. 같은 분이면 upsert 라 행이 중복되지 않는다.
        displayPtAddrs() {
            this.snapshotLiveStack();
        },
    },
    methods: {
        onRowClick(rows) {
            this.$emit("select-row", rows[0].ptVal);
        },

        /**
         * 로컬 스택(liveStackRows)을 주어진 ptAddr 목록 순서로 추려 화면용 행 배열을 만든다.
         * 누적 시점에 비어 있던 셀(연결 직후 등)은 현재 라이브 값(liveReals)으로 폴백한다.
         * 최신 행이 위로 오도록 자체 배열을 뒤집어 반환한다.
         * @param {string[]} ptAddrs 컬럼 순서대로의 관제점 주소 목록
         * @returns {Array<{regDt: string, datas: Array<{ptAddr: string, ptVal: number|null}>}>}
         */
        buildRows(ptAddrs) {
            const columns = ptAddrs || [];
            const live = this.liveReals || {};

            return this.liveStackRows
                .map((row) => ({
                    regDt: row.regDt,
                    datas: columns.map((ptAddr) => {
                        const cell = row.datas.find((d) => d.ptAddr === ptAddr);
                        if (cell) return cell;

                        const ptVal = live[ptAddr] ? live[ptAddr].ptVal : null;
                        return { ptAddr, ptVal };
                    }),
                }))
                .reverse();
        },

        /**
         * 현재 분 행에 표시 대상 관제점(displayPtAddrs)의 totalReal 값을 스냅샷한다.
         * 같은 분이면 ptAddr 단위 upsert(새 행은 바로 push)로 중복을 막고, 최대 MAX_STACK_ROWS 행을 유지한다.
         * ws 연결이 끊긴 동안엔 totalReal 이 얼어붙으므로 stale 값을 박제하지 않도록 건너뛴다.
         */
        snapshotLiveStack() {
            if (!this.$store.getters.isWscConnected) return;

            const ptAddrs = this.displayPtAddrs;
            if (ptAddrs.length === 0) return;

            const totalReal = this.$store.getters.getTotalReal || {};
            const regDt = moment().format("YYYYMMDDHHmm");
            const rows = this.liveStackRows;

            let regIdx = rows.findIndex((r) => r.regDt === regDt);
            if (regIdx === -1) {
                rows.push({ regDt, datas: [] });
                regIdx = rows.length - 1;
            }

            const datas = rows[regIdx].datas;
            const isNewRow = datas.length === 0;
            for (let i = 0; i < ptAddrs.length; i++) {
                const ptAddr = ptAddrs[i];
                const ptVal = totalReal[ptAddr] ? totalReal[ptAddr].ptVal : null;

                if (isNewRow) {
                    datas.push({ ptAddr, ptVal });
                    continue;
                }
                const cellIdx = datas.findIndex((d) => d.ptAddr === ptAddr);
                if (cellIdx === -1) datas.push({ ptAddr, ptVal });
                else datas[cellIdx].ptVal = ptVal;
            }

            if (rows.length > MAX_STACK_ROWS) rows.shift();
        },

        /** 스택 누적 시작: 지난 방문의 stale 행 리셋 → 즉시 1행(prime) → 주기 틱 시작(중복 인터벌 가드). */
        startLiveStack() {
            this.stopLiveStack();
            this.liveStackRows = [];
            this.snapshotLiveStack();
            this.stackTimer = setInterval(this.snapshotLiveStack, STACK_TICK_MS);
        },

        /** 스택 누적 타이머 정리. */
        stopLiveStack() {
            if (this.stackTimer) {
                clearInterval(this.stackTimer);
                this.stackTimer = null;
            }
        },
    },
};
</script>
